import { useContext } from 'react';

import { TripListItemContext } from './trip-list-item-context';

export const useTripListItem = () => {
  return useContext(TripListItemContext);
};
